export const INIT_APP = 'INIT_APP'
export const RACE_AVAILABLE_ORIGIN = 'RACE_AVAILABLE_ORIGIN'
